import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { SignupModalComponent } from './signup-modal/signup-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ForgotPasswordModalComponent } from './forgot-password-modal/forgot-password-modal.component';


@NgModule({
  declarations: [
    LoginModalComponent,
    SignupModalComponent,
    ForgotPasswordModalComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSnackBarModule,
  ]
})
export class AuthModule { }
